import { ApolloLink } from "@apollo/client";
import { GraphQLError } from "graphql";
import { isMutationOperation } from "@/lib/apollo/apollo.utils";
import { DjangoMutationError } from "@/utils/djangoMutationError";

export function getCustomErrorLink() {
  return new ApolloLink((operation, forward) => {
    // This is a custom (Django) mutation error handler.
    if (isMutationOperation(operation)) {
      return forward(operation).map((response) => {
        // Hasura error: Generic error.
        if (response.errors) {
          return response;
        }

        const dataKey = Object.keys(response.data)[0];
        const data = response.data[dataKey];

        // Hasura error: Row update mutation failed - missing permission.
        if (!data) {
          response.errors = [
            new GraphQLError(
              "Unexpected mutation response - no data returned. Likely missing permission to perform this action."
            ),
            ...(response.errors || []),
          ];

          return response;
        }

        // Django error: Generic error.
        if ("ok" in data && !data.ok) {
          const { message } = data;

          if (message) {
            response.errors = [
              new DjangoMutationError(message),
              ...(response.errors || []),
            ];
          } else {
            response.errors = [
              new GraphQLError(
                "Unexpected response from Django custom mutation. No message provided"
              ),
              ...(response.errors || []),
            ];
          }
        }

        return response;
      });
    } else return forward(operation);
  });
}
